module.exports = __webpack_public_path__ + "img/Wachtkamer.aef9b6ff.jpg";